import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { observer } from 'mobx-react';
import Model from '../../model/ShopKeeper.model';
import LoadingPage from '../../../LoadingPage';

/* The following can occur when PACCAR Loyalty Offers are redeemed:

  1. In the "PROCESSING" state, a red "Cancel" button is available.
     This is useful if the API call hangs indefinitely.  If clicked, any
     pending request will NOT be bound to line items if it eventually resolves
     (its process closure will effectively be canceled).  Upon cancel, the
     status mode will be set to "CANCELED", and the modal will enter the same
     UX choice selection as it would if the API call had resulted in an error
     (see next).

  2. An error sate is inferred any time we receive no redemptions for any given
     offer. We don't care why, logically. Under an error state, the user has the
     option to either try again, or remove unredeemed offers and proceed to process
     the invoice (or close the modal and inspect the offer lines within the invoice
     builder, but this will most likely not happen much.)

     Again, the displayed UX options on ERROR/CANCELED status will be:
     A. TRY AGAIN - Will try to redeem ONLY those lines which were not previously successful
     B. REMOVE FAILED OFFERS & PROCEED - Simply remove the failed offers and proceed
        to process the invoice

  3. Partially redeemed offers will NOT, by themselves, create an error state,
     as the natural choice a clerk would make in such a case would be to take
     whatever PACCAR is willing to redeem.  Thus if this is the only "error"
     condition, the process will proceed as normal.  The invoice total will
     automatically reflect the reduced redeemed amount before proceeding to
     credit check, fleet bill, and invoice process.
*/

interface IProps {
  cancel: Function;
  container: Object;
  hide: Function;
  model: Model;
  removeUnredeemedAndProcessInvoice: Function;
  show: boolean;
  tryAgain: Function;
}

@observer
class ProcessLoyaltyRedemptionsModal extends Component<IProps, {}> {
  render() {
    const model = this.props.model;
    const processing = model.loyaltyProcessStatus === 'PROCESSING';
    const error = model.loyaltyProcessStatus === 'ERROR';

    return (
      <Modal
        backdrop="static"
        container={this.props.container as any}
        dialogClassName="sk-processLoyaltyRedemptionsModal"
        onHide={() => {
          /* No "X" to hide, "Cancel" (process) only */
        }}
        show={this.props.show}
      >
        <Modal.Header>
          <Modal.Title>PACCAR Loyalty Program</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {processing && (
            <div className="sk-loyaltyProcessing">
              <div className="sk-pleaseWait">
                Redeeming Loyalty Offers
                <br />
                (Please Wait)
              </div>
              <LoadingPage hideRefreshMessage={true} />
            </div>
          )}
          {error && (
            <div className="sk-errorOrCancel">
              One or more offers have failed to redeem with PACCAR. What do you wish to do?
              <div className="sk-actionItem" onClick={() => this.props.tryAgain()}>
                <i className="zmdi zmdi-refresh-alt" /> Try to redeem failed offers again.
              </div>
              <div className="sk-actionItem" onClick={() => this.props.removeUnredeemedAndProcessInvoice()}>
                <i className="zmdi zmdi-delete" /> &nbsp;Remove unredeemed offers and process invoice.
              </div>
              <div className="sk-actionItem" onClick={() => this.props.hide()}>
                <i className="zmdi zmdi-edit" /> Return to main invoice screen.
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {processing && (
            <Button variant="danger" onClick={() => this.props.cancel()}>
              Cancel
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ProcessLoyaltyRedemptionsModal;
